// @flow
import React, { useState, useEffect } from 'react';
import { Modal, Icon } from 'antd';
import { SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  submitting: boolean,
};

const ConfirmPopup = (props: Props) => {
  const {
    visible,
    close,
    submit,
    submitting,
  } = props;

  const [disableButton, setDisableButton] = useState(false);

  useEffect(() => {
    if (!submitting) {
      setDisableButton(false);
    }
  }, [submitting]);

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={() => { submit(); setDisableButton(true); }} type="primary" disabled={disableButton}>Apply</SpButton>,
      ]}
      title="Confirmation"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">You are adding another bank account to the Transfer Center. <br />
          Please check your email to verify your ownership.
        </div>
        <div className="pb-3">
          <Icon
            type="warning"
            style={{ fontSize: '20px', color: '#FF0000' }}
            className="mr-2"
          />
          <span style={{ color: '#E67300' }}>Added acounts are for internal users, if you would like to send funds to
            another party please add them in the Contacts menu.
          </span>
        </div>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default ConfirmPopup;
